<template>
  <div>
    <div v-if="loading" class="text-center tw-my-10">
      <i class="fas fa-spinner fa-spin fa-2x"/>
    </div>

    <slot v-if="startLoading"></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      startLoading: false,
      loading: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.startLoading = true

      this.$nextTick(() => {
        setTimeout(() => {
          this.loading = false
        }, 0)
      })
    }, 50)
  }
}
</script>